
import { addProductCategory } from "apis/product.api";
import FormController from "pages/layout/FormController";
import { memo, useMemo, } from "react";



const ProductCategoryFormController = function () {


    const fieldSchema = useMemo(
        () => [
            {
                title: "Name",
                placeholder: "Enter name",
                key: "name",
                type: "text",
                required: true,
                default: "",
            },
            {
                title: "Priority",
                placeholder: "Enter priority",
                key: "priority",
                type: "number",
                required: true,
                default: "",
            },
        ],
        []
    );
    return <FormController

        routeForRedirect="/product-category/"
        title=" Product Category"
        inputFiedsSchema={fieldSchema}
        addFun={addProductCategory}
        getByIdFun={() => { }}
        updateFun={() => { }}

    />
};
export default memo(ProductCategoryFormController);
